import useSWR, { type SWRResponse } from "swr";
import { useApiClient } from "@/hooks/useApiClient";
import {
  CORPORATE_MASTER_REGISTRY_TAGS_API_PATH,
  getCorporateMasterRegistryTags,
} from "../api";
import { inlineErrorSwrOptions } from "./inlineErrorSwrOptions";
import type { RegistryTagOptionResponse } from "../types";

/**
 * 公的名簿から決まるタグ（公表情報）の一覧を取得する。検索条件の選択肢に使う
 * @returns SWRレスポンス
 */
export const useCorporateMasterRegistryTags = (): SWRResponse<
  RegistryTagOptionResponse,
  Error
> => {
  const { apiClient } = useApiClient();
  return useSWR<RegistryTagOptionResponse, Error>(
    CORPORATE_MASTER_REGISTRY_TAGS_API_PATH,
    async () => await getCorporateMasterRegistryTags(apiClient),
    { revalidateOnFocus: false, ...inlineErrorSwrOptions }
  );
};
